module.exports = MathJax;


//////////////////
// WEBPACK FOOTER
// external "MathJax"
// module id = 7
// module chunks = 0 2